import { useState } from 'react';
import { motion } from 'framer-motion';

interface Props {
  firmId: string;
  code?: string | null;
  percent?: number | null;
  validUntilRemark?: string | null;
  firstPurchaseOnly?: boolean;
  className?: string;
}

export const PromoCTAButton = ({
  firmId,
  code,
  percent,
  validUntilRemark,
  firstPurchaseOnly,
  className = '',
}: Props) => {
  const [revealed, setRevealed] = useState(false);

  const isPromoActive = code !== null;

  const handleReveal = () => {
    setRevealed(true);
  };

  const extraRemark =
    validUntilRemark
      ? validUntilRemark
      : firstPurchaseOnly
        ? 'Limited offer'
        : null;

  return (
    <div className={`flex flex-col items-center ${className}`}>
      {isPromoActive ? (
        !revealed ? (
          <button
            onClick={handleReveal}
            className="w-full md:w-[180px] h-10 px-4 py-2 text-sm font-semibold text-black bg-yellow-500 hover:bg-yellow-400 rounded transition"
          >
            {percent ? `${percent}% Discount!` : 'Claim Discount'}
          </button>
        ) : (
          <motion.a
            href={`/go/${firmId}`}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.2 }}
            className="w-full md:w-[180px] h-10 flex items-center justify-center px-4 py-2 text-sm font-semibold text-black bg-yellow-500 hover:bg-yellow-400 rounded transition"
          >
            Use Code: {code}
          </motion.a>
        )
      ) : (
        <a
          href={`/go/${firmId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full md:w-[180px] h-10 flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-gray-700 hover:bg-gray-600 rounded transition"
        >
          Get Funded
        </a>
      )}

      {/* Only show remark if promo code exists */}
      {isPromoActive && extraRemark && (
        <div className="text-xs text-yellow-400 mt-1 text-center">{extraRemark}</div>
      )}
    </div>
  );
};

export default PromoCTAButton;
